var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70571 3.73512V4.26453C7.70571 4.41073 7.5872 4.52924 7.441 4.52924H4.52924V7.441C4.52924 7.5872 4.41073 7.70571 4.26453 7.70571H3.73512C3.58893 7.70571 3.47042 7.5872 3.47042 7.441V4.52924H0.558651C0.412458 4.52924 0.293945 4.41073 0.293945 4.26453V3.73512C0.293945 3.58893 0.412458 3.47042 0.558651 3.47042H3.47042V0.558651C3.47042 0.412458 3.58893 0.293945 3.73512 0.293945H4.26453C4.41073 0.293945 4.52924 0.412458 4.52924 0.558651V3.47042H7.441C7.5872 3.47042 7.70571 3.58893 7.70571 3.73512Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.782b22396823638d7d3bef948c92d7b0.svg";
export { ForwardRef as ReactComponent };